var windowLocation = "profile.html"

$(document).ready(function() {

  if ($('#leaveSetup')) {
    $('#leaveSetup .bttn-danger').on('click', function() {
      setTimeout(function() {
        window.location = windowLocation;
      }, 200)
    });
  }

});
